import $ from 'jquery';
import fancybox from 'fancybox';

fancybox($);

export default $;
